export default function VideoCardSkeleton() {
  return (
    <div className="overflow-hidden rounded-lg border border-background-800 bg-background-900">
      <div className="aspect-video w-full animate-pulse bg-background-800" />
      <div className="space-y-3 p-4">
        <div className="h-2.5 w-1/3 animate-pulse rounded bg-background-800" />
        <div className="h-3.5 w-3/4 animate-pulse rounded bg-background-800" />
        <div className="h-2.5 w-full animate-pulse rounded bg-background-800" />
        <div className="h-2.5 w-2/3 animate-pulse rounded bg-background-800" />
      </div>
    </div>
  );
}